import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = { class: "iconContentWrapper" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = {
  class: "title",
  role: "heading",
  "aria-level": "3",
  "aria-label": "warning title"
}
const _hoisted_7 = ["innerHTML"]

import { markdownToHtml } from '@components/helpers';
import {
  nextTick, onMounted, ref, watch,
} from 'vue';
import { Icon } from '../../Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'WarningCard',
  props: {
    title: {},
    text: {},
    isExpanded: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const warningText = ref<HTMLElement | null>(null);
const isPanelExpanded = ref(props.isExpanded);
const showArrow = ref(false);

function checkOverflow() {
  const el = warningText.value;
  if (!el) return;
  showArrow.value = el.scrollHeight > el.clientHeight;
}

onMounted(async () => {
  await nextTick();
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      checkOverflow();
    });
  });
});

watch(() => props.text, async () => {
  isPanelExpanded.value = false; // reset expanded state for new content
  await nextTick();
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      checkOverflow();
    });
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      "aria-label": `${isPanelExpanded.value ? 'Collapsed warning' : 'Expanded warning'}`,
      class: _normalizeClass(['warningCard', { expanded: isPanelExpanded.value }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isPanelExpanded.value = !isPanelExpanded.value))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Icon), {
            class: "warningIcon",
            "icon-name": "warning"
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", {
              ref_key: "warningText",
              ref: warningText,
              class: "text",
              role: "heading",
              "aria-level": "3",
              "aria-label": "warning text",
              innerHTML: _unref(markdownToHtml)(_ctx.text)
            }, null, 8, _hoisted_7)
          ])
        ]),
        (showArrow.value)
          ? (_openBlock(), _createBlock(_unref(Icon), {
              key: 0,
              class: "arrow",
              "icon-name": "redChevron"
            }))
          : _createCommentVNode("", true)
      ])
    ], 10, _hoisted_2)
  ]))
}
}

})